import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.matchOverwrites.loading,
  writing: state.matchOverwrites.writing,
  overwrites: state.matchOverwrites.overwrites,
  writeError: state.matchOverwrites.writeError,
  fetchOverwriteError: state.matchOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
